import React, { useState, useEffect } from 'react';
import VideoServices from '../../services/VideoServices';

function TradingVideo() {
  const [contactData, setContactData] = useState([]);

  useEffect(() => {
    VideoServices.getVideo()
      .then((response) => {
        console.log(response);
        setContactData(response?.data || []);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  // Function to extract YouTube video ID from full link
  const getYouTubeID = (url) => {
    const regExp = /^.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=)([^#\&\?]*).*/;
    const match = url.match(regExp);
    return match && match[1].length === 11 ? match[1] : null;
  };

  return (
    <div>
      <div className="contact-us-section py-70">
        <div className="container">
          <div className="get-in-touch-section">
            <h2 className="heading text-center d-block mb-3">Videos</h2>
            <div className="get-in-touch-inner my-5">
              <div className="row gy-4">
                {contactData.map((data, index) => {
                  const videoId = getYouTubeID(data.link);
                  return (
                    <div className="col-lg-4 col-sm-6" key={index}>
                      <div className="contact-us-box">
                        <h4 className="text-center">{data.title}</h4>
                        {videoId ? (
                          <iframe
                            width="100%"
                            height="200"
                            src={`https://www.youtube.com/embed/${videoId}`}
                            title={data.title}
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                          ></iframe>
                        ) : (
                          <p>Invalid video link</p>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TradingVideo;
